export enum EDesignType {
  Row = 0,
  Box = 1
}
